// extracted by mini-css-extract-plugin
export default {"linkButton":"link_button-module___linkButton___d3a9629e"};